"use client";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createElement } from "react";
import { CaretDown, CaretUp, File } from "@phosphor-icons/react";
import { ICONS } from "./Icons";
import { ItemWrapper } from "./ItemWrapper";
import { menuItemRecipe } from "./recipes";
const getIcon = (icon) => {
    var _a;
    const IconComponent = (_a = ICONS[icon]) !== null && _a !== void 0 ? _a : File;
    return createElement(IconComponent, { weight: "fill" });
};
export const MenuItem = ({ icon, title, displayText, isActive, isInternal = false, interpolatedLocation, hasScrollbar = false, isExpanded = false, hasChildren = false, asChild = false, }) => {
    const styles = menuItemRecipe({
        displayText,
        isActive,
        hasScrollbar,
        isExpanded,
        hasChildren,
        asChild,
    });
    return (_jsx(ItemWrapper, { role: "button", href: interpolatedLocation, isInternal: isInternal, className: styles.wrapper, title: !displayText ? title : "", children: _jsxs("div", { className: styles.container, children: [_jsx("div", { className: styles.icon, children: getIcon(icon) }), _jsx("div", { className: styles.text, children: title }), isExpanded && hasChildren && displayText && _jsx(CaretUp, {}), !isExpanded && hasChildren && displayText && _jsx(CaretDown, {})] }) }));
};
//# sourceMappingURL=MenuItem.js.map